import Vue from 'vue'
import Router from 'vue-router'
import index from 'components/index.vue'
import login from 'components/login.vue'
import consult from 'components/consult.vue'
import rule from 'components/rule.vue'
import my from 'components/my.vue'
import feedback from 'components/feedback.vue'
import news from 'components/news.vue'
import psychology from 'components/psychology.vue'
import evaluate from 'components/evaluate.vue'
import personalData from 'components/personalData.vue'
import myUsers from 'components/myUsers.vue'
import record from 'components/record.vue'
import userDetails from 'components/userDetails.vue'
import agoar from 'components/agoar.vue'
import scheduling from 'components/scheduling.vue'
import timeSetting from 'components/timeSetting.vue'
import help from 'components/help.vue'
import changePhone from 'components/changePhone.vue'
import chat from 'components/chat.vue'
import reply from 'components/reply.vue'
import serviceAssistant from 'components/serviceAssistant.vue'
import serviceAssistantDetail from 'components/serviceAssistantDetail.vue'
import recordDetails from 'components/recordDetails.vue'
import article from 'components/article.vue'
import leave from 'components/leave.vue'
import task from 'components/task.vue'
import taskDetail from 'components/taskDetail.vue'
import offlineLectures from 'components/offlineLectures.vue'
import consultingScheduling from 'components/consultingScheduling.vue'
import create from 'components/create.vue'
import rules from 'components/rules.vue'
import result from 'components/result.vue'
import label from 'components/label.vue'
import selectTime from 'components/selectTime.vue'
import wxAuth from 'components/user/wx-auth.vue'
import autoLogin from 'components/user/auto-login.vue'
import submitApplication from 'components/application/index.vue'
import applicationMsg from 'components/application/message.vue'
import applicationList from 'components/application/list.vue'


Vue.use(Router)

export default new Router({
    mode:"hash",
    base:'/teacher',
    routes: [
        {
            path: '/',
            name: 'index',
            component: index
        },
        {
            path: '/label',
            name: 'label',
            component: label
        },
        {
            path: '/selectTime',
            name: 'selectTime',
            component: selectTime
        },
        {
            path: '/result',
            name: 'result',
            component: result
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/create',
            name: 'create',
            component: create
        },
        {
            path: '/rules',
            name: 'rules',
            component: rules
        },
        {
            path: '/consult',
            name: 'consult',
            component: consult
        },
        {
            path: '/rule',
            name: 'rule',
            component: rule
        },
        {
            path: '/my',
            name: 'my',
            component: my
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: feedback
        },
        {
            path: '/news',
            name: 'news',
            component: news
        },
        {
            path: '/psychology',
            name: 'psychology',
            component: psychology
        },
        {
            path: '/evaluate',
            name: 'evaluate',
            component: evaluate
        },
        {
            path: '/personalData',
            name: 'personalData',
            component: personalData
        },
        {
            path: '/myUsers',
            name: 'myUsers',
            component: myUsers
        },
        {
            path: '/record',
            name: 'record',
            component: record
        },
        {
            path: '/userDetails',
            name: 'userDetails',
            component: userDetails
        },
        {
            path: '/agoar',
            name: 'agoar',
            component: agoar
        },
        {
            path: '/scheduling',
            name: 'scheduling',
            component: scheduling
        },
        {
            path: '/timeSetting',
            name: 'timeSetting',
            component: timeSetting
        },
        {
            path: '/help',
            name: 'help',
            component: help
        },
        {
            path: '/changePhone',
            name: 'changePhone',
            component: changePhone
        },
        {
            path: '/chat',
            name: 'chat',
            component: chat
        },
        {
            path: '/reply',
            name: 'reply',
            component: reply
        },
        {
            path: '/serviceAssistant',
            name: 'serviceAssistant',
            component: serviceAssistant
        },
        {
            path: '/serviceAssistantDetail',
            name: 'serviceAssistantDetail',
            component: serviceAssistantDetail
        },
        {
            path: '/recordDetails',
            name: 'recordDetails',
            component: recordDetails
        },
        {
            path: '/article',
            name: 'article',
            component: article
        },
        {
            path: '/leave',
            name: 'leave',
            component: leave
        },
        {
            path: '/task',
            name: 'task',
            component: task
        },
        {
            path: '/taskDetail',
            name: 'taskDetail',
            component: taskDetail
        },
        {
            path: '/offlineLectures',
            name: 'offlineLectures',
            component: offlineLectures
        },
        {
            path: '/consultingScheduling',
            name: 'consultingScheduling',
            component: consultingScheduling
        },
        {
            path: '/wx-auth',
            name: 'wxAuth',
            component: wxAuth
        },
        {
            path: '/auto-login',
            name: 'autoLogin',
            component: autoLogin
        },
        {
            path: '/application',
            name: 'submitApplication',
            component: submitApplication
        },
        {
            path: '/application_msg',
            name: 'applicationMsg',
            component: applicationMsg
        },
        {
            path: '/application_list',
            name: 'applicationList',
            component: applicationList
        }

  ],
    scrollBehavior(to,from,savedPosition){
        return {x:0,y:0}
    },
})





// WEBPACK FOOTER //
// ./src/router/index.js